import { Controller } from "stimulus";
import copy from "clipboard-copy";

export default class extends Controller {
    print() {
        window.print();
    }

    copy() {
        copy(window.location.href)
            .then(() => {
                alert("Page link copied.");
            })
            .catch(() => {
                alert(
                    "There was a problem copying the page link. Please try again."
                );
            });
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/share_controller.js